import { AccountInfo } from "@azure/msal-browser";
import { isAdfs } from "./authProviderUtils";
import { Role, RolesAdfs } from "../../constants/roles";

export function resolveRoles(account: AccountInfo | null): Role[] {
  if (!account) return [];

  const claims = account.idTokenClaims as any;
  const userRoles: Role[] = claims?.roles || claims?.groups || [];

  let finalRoles = isAdfs() ? [...userRoles, ...RolesAdfs] : userRoles;

  if (process.env.NODE_ENV === "development") {
    const mockRoles = process.env.REACT_APP_MOCK_ROLES?.split(",") as Role[] | undefined;
    if (mockRoles?.length) {
      finalRoles = Array.from(new Set([...mockRoles]));
    }
  }

  return finalRoles;
}
